function dataLayerNavClick(eventType, menuType, itemName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventType,
    menu_type: menuType,
    menu_item_name: itemName,
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Header Navigation
  let desktopNav = document.querySelector(".header__menu"); // adjust class if needed, per HTML structure
  if (desktopNav) {
    desktopNav.addEventListener("click", function (evt) {
      let desktopNavLink = evt.target.closest(".navlink");
      if (desktopNavLink) {
        dataLayerNavClick(
          "navigation_click",
          "header",
          desktopNavLink.innerText.trim()
        );
      }
    });
  }

  // Footer Navigation
  let footerNav = document.querySelector(".supporting-menu__copyright"); // adjust class if needed, per HTML structure
  if (footerNav) {
    footerNav.addEventListener("click", function (evt) {
      let footerNavLink = evt.target.closest("a");
      if (footerNavLink) {
        dataLayerNavClick(
          "navigation_click",
          "footer",
          footerNavLink.innerText.trim()
        );
      }
    });
  }
});